import { render, staticRenderFns } from "./ComplementaryMaterials.vue?vue&type=template&id=6e709999&scoped=true"
import script from "./ComplementaryMaterials.vue?vue&type=script&lang=js"
export * from "./ComplementaryMaterials.vue?vue&type=script&lang=js"
import style0 from "./ComplementaryMaterials.vue?vue&type=style&index=0&id=6e709999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e709999",
  null
  
)

export default component.exports